import { StyledButton } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 0;
  background-color: rgba(21, 28, 43, 1) !important;
  background: radial-gradient(ellipse 70% 30% at bottom center, rgba(100, 20, 50, 0.8) 0%, rgba(255, 255, 255, 0) 80%);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(21, 28, 43, 1) !important;
    background: radial-gradient(
      ellipse 70% 30% at bottom center,
      rgba(100, 20, 50, 0.8) 0%,
      rgba(255, 255, 255, 0) 80%
    );
    z-index: -1;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  gap: 2.4rem;
  flex-direction: column;
  align-items: center;
  padding: 4.6rem;

  p {
    font-family: ${({ theme }) => theme.fonts.familySansPro};
    color: ${({ theme }) => theme.colors.white};
    font-size: 1.8rem;
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    margin-bottom: 2rem;
    strong {
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }
`;

export const Styledtag = styled.span`
  background-color: rgba(45, 61, 95, 1);
  color: rgba(113, 156, 249, 1);
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin: 0;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  display: block;
  width: fit-content;
  padding: 0.7rem 1.2rem;
  border-radius: 10rem;
`;

export const StyledMainText = styled.h2`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: white;
  text-transform: uppercase;
  margin-bottom: 1rem;
  font-weight: 900;
  font-size: 3.2rem;
  letter-spacing: -0.03em;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }
`;

export const StyledCountdownWrapper = styled.div`
  margin: 0;
  display: flex;
  gap: 0.6rem;
  flex-direction: column;
  justify-content: center;

  > p {
    margin: 0;
    font-size: 1.6rem;
    font-weight: ${({ theme }) => theme.fonts.weight.regular};
  }
`;

export const StyledRedirectButton = styled(StyledButton)`
  background-color: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.6rem;
  font-weight: ${({ theme }) => theme.fonts.weight.regular} !important;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: bold;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary.light};
  }
`;
